import { render, staticRenderFns } from "./CtcFullRegApproval.vue?vue&type=template&id=af8003ba&scoped=true"
import script from "./CtcFullRegApproval.vue?vue&type=script&lang=js"
export * from "./CtcFullRegApproval.vue?vue&type=script&lang=js"
import style0 from "./CtcFullRegApproval.vue?vue&type=style&index=0&id=af8003ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8003ba",
  null
  
)

export default component.exports